import shopcart from './shopcart';
import pickers from './pickers';
import addaddress from './addaddress';
import orderdata from './orderdata';
export default {
  shopcart,
  pickers,
  addaddress,
  orderdata,
};
